// Generated from src/main/_entity/expression/antlr/Expression.g4 by ANTLR 4.9.0-SNAPSHOT
import { ATNDeserializer } from "antlr4ts/atn/ATNDeserializer.js";
import { Lexer } from "antlr4ts/Lexer.js";
import { LexerATNSimulator } from "antlr4ts/atn/LexerATNSimulator.js";
import { VocabularyImpl } from "antlr4ts/VocabularyImpl.js";
import * as Utils from "antlr4ts/misc/Utils.js";
export class ExpressionLexer extends Lexer {
    static ATOM = 1;
    static TERM = 2;
    static NUMBER = 3;
    static PLUS = 4;
    static MINUS = 5;
    static STAR = 6;
    static SLASH = 7;
    static EQ = 8;
    static NEQ = 9;
    static LTE = 10;
    static GTE = 11;
    static LT = 12;
    static GT = 13;
    static AND = 14;
    static OR = 15;
    static NOT = 16;
    static COMMA = 17;
    static LPAREN = 18;
    static RPAREN = 19;
    static LBRACK = 20;
    static RBRACK = 21;
    static WS = 22;
    // tslint:disable:no-trailing-whitespace
    static channelNames = [
        "DEFAULT_TOKEN_CHANNEL", "HIDDEN",
    ];
    // tslint:disable:no-trailing-whitespace
    static modeNames = [
        "DEFAULT_MODE",
    ];
    static ruleNames = [
        "ATOM", "TERM", "NUMBER", "PLUS", "MINUS", "STAR", "SLASH", "EQ", "NEQ",
        "LTE", "GTE", "LT", "GT", "AND", "OR", "NOT", "COMMA", "LPAREN", "RPAREN",
        "LBRACK", "RBRACK", "WS",
    ];
    static _LITERAL_NAMES = [
        undefined, undefined, undefined, undefined, "'+'", "'-'", "'*'", "'/'",
        "'='", "'!='", "'<='", "'>='", "'<'", "'>'", "'&&'", "'||'", "'!'", "','",
        "'('", "')'", "'['", "']'",
    ];
    static _SYMBOLIC_NAMES = [
        undefined, "ATOM", "TERM", "NUMBER", "PLUS", "MINUS", "STAR", "SLASH",
        "EQ", "NEQ", "LTE", "GTE", "LT", "GT", "AND", "OR", "NOT", "COMMA", "LPAREN",
        "RPAREN", "LBRACK", "RBRACK", "WS",
    ];
    static VOCABULARY = new VocabularyImpl(ExpressionLexer._LITERAL_NAMES, ExpressionLexer._SYMBOLIC_NAMES, []);
    // @Override
    // @NotNull
    get vocabulary() {
        return ExpressionLexer.VOCABULARY;
    }
    // tslint:enable:no-trailing-whitespace
    constructor(input) {
        super(input);
        this._interp = new LexerATNSimulator(ExpressionLexer._ATN, this);
    }
    // @Override
    get grammarFileName() { return "Expression.g4"; }
    // @Override
    get ruleNames() { return ExpressionLexer.ruleNames; }
    // @Override
    get serializedATN() { return ExpressionLexer._serializedATN; }
    // @Override
    get channelNames() { return ExpressionLexer.channelNames; }
    // @Override
    get modeNames() { return ExpressionLexer.modeNames; }
    static _serializedATN = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x02\x18x\b\x01\x04" +
        "\x02\t\x02\x04\x03\t\x03\x04\x04\t\x04\x04\x05\t\x05\x04\x06\t\x06\x04" +
        "\x07\t\x07\x04\b\t\b\x04\t\t\t\x04\n\t\n\x04\v\t\v\x04\f\t\f\x04\r\t\r" +
        "\x04\x0E\t\x0E\x04\x0F\t\x0F\x04\x10\t\x10\x04\x11\t\x11\x04\x12\t\x12" +
        "\x04\x13\t\x13\x04\x14\t\x14\x04\x15\t\x15\x04\x16\t\x16\x04\x17\t\x17" +
        "\x03\x02\x03\x02\x06\x022\n\x02\r\x02\x0E\x023\x03\x03\x03\x03\x06\x03" +
        "8\n\x03\r\x03\x0E\x039\x03\x04\x06\x04=\n\x04\r\x04\x0E\x04>\x03\x04\x03" +
        "\x04\x06\x04C\n\x04\r\x04\x0E\x04D\x05\x04G\n\x04\x03\x05\x03\x05\x03" +
        "\x06\x03\x06\x03\x07\x03\x07\x03\b\x03\b\x03\t\x03\t\x03\n\x03\n\x03\n" +
        "\x03\v\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\x0E\x03\x0E\x03\x0F" +
        "\x03\x0F\x03\x0F\x03\x10\x03\x10\x03\x10\x03\x11\x03\x11\x03\x12\x03\x12" +
        "\x03\x13\x03\x13\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17" +
        "\x06\x17s\n\x17\r\x17\x0E\x17t\x03\x17\x03\x17\x02\x02\x02\x18\x03\x02" +
        "\x03\x05\x02\x04\x07\x02\x05\t\x02\x06\v\x02\x07\r\x02\b\x0F\x02\t\x11" +
        "\x02\n\x13\x02\v\x15\x02\f\x17\x02\r\x19\x02\x0E\x1B\x02\x0F\x1D\x02\x10" +
        "\x1F\x02\x11!\x02\x12#\x02\x13%\x02\x14\'\x02\x15)\x02\x16+\x02\x17-\x02" +
        "\x18\x03\x02\x04\x03\x022;\x05\x02\v\f\x0F\x0F\"\"\x02}\x02\x03\x03\x02" +
        "\x02\x02\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02\t\x03\x02" +
        "\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0F\x03\x02\x02" +
        "\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02" +
        "\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1B\x03\x02\x02" +
        "\x02\x02\x1D\x03\x02\x02\x02\x02\x1F\x03\x02\x02\x02\x02!\x03\x02\x02" +
        "\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02\'\x03\x02\x02\x02\x02" +
        ")\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x03/\x03\x02" +
        "\x02\x02\x055\x03\x02\x02\x02\x07<\x03\x02\x02\x02\tH\x03\x02\x02\x02" +
        "\vJ\x03\x02\x02\x02\rL\x03\x02\x02\x02\x0FN\x03\x02\x02\x02\x11P\x03\x02" +
        "\x02\x02\x13R\x03\x02\x02\x02\x15U\x03\x02\x02\x02\x17X\x03\x02\x02\x02" +
        "\x19[\x03\x02\x02\x02\x1B]\x03\x02\x02\x02\x1D_\x03\x02\x02\x02\x1Fb\x03" +
        "\x02\x02\x02!e\x03\x02\x02\x02#g\x03\x02\x02\x02%i\x03\x02\x02\x02\'k" +
        "\x03\x02\x02\x02)m\x03\x02\x02\x02+o\x03\x02\x02\x02-r\x03\x02\x02\x02" +
        "/1\x07C\x02\x0202\t\x02\x02\x0210\x03\x02\x02\x0223\x03\x02\x02\x0231" +
        "\x03\x02\x02\x0234\x03\x02\x02\x024\x04\x03\x02\x02\x0257\x07V\x02\x02" +
        "68\t\x02\x02\x0276\x03\x02\x02\x0289\x03\x02\x02\x0297\x03\x02\x02\x02" +
        "9:\x03\x02\x02\x02:\x06\x03\x02\x02\x02;=\t\x02\x02\x02<;\x03\x02\x02" +
        "\x02=>\x03\x02\x02\x02><\x03\x02\x02\x02>?\x03\x02\x02\x02?F\x03\x02\x02" +
        "\x02@B\x070\x02\x02AC\t\x02\x02\x02BA\x03\x02\x02\x02CD\x03\x02\x02\x02" +
        "DB\x03\x02\x02\x02DE\x03\x02\x02\x02EG\x03\x02\x02\x02F@\x03\x02\x02\x02" +
        "FG\x03\x02\x02\x02G\b\x03\x02\x02\x02HI\x07-\x02\x02I\n\x03\x02\x02\x02" +
        "JK\x07/\x02\x02K\f\x03\x02\x02\x02LM\x07,\x02\x02M\x0E\x03\x02\x02\x02" +
        "NO\x071\x02\x02O\x10\x03\x02\x02\x02PQ\x07?\x02\x02Q\x12\x03\x02\x02\x02" +
        "RS\x07#\x02\x02ST\x07?\x02\x02T\x14\x03\x02\x02\x02UV\x07>\x02\x02VW\x07" +
        "?\x02\x02W\x16\x03\x02\x02\x02XY\x07@\x02\x02YZ\x07?\x02\x02Z\x18\x03" +
        "\x02\x02\x02[\\\x07>\x02\x02\\\x1A\x03\x02\x02\x02]^\x07@\x02\x02^\x1C" +
        "\x03\x02\x02\x02_`\x07(\x02\x02`a\x07(\x02\x02a\x1E\x03\x02\x02\x02bc" +
        "\x07~\x02\x02cd\x07~\x02\x02d \x03\x02\x02\x02ef\x07#\x02\x02f\"\x03\x02" +
        "\x02\x02gh\x07.\x02\x02h$\x03\x02\x02\x02ij\x07*\x02\x02j&\x03\x02\x02" +
        "\x02kl\x07+\x02\x02l(\x03\x02\x02\x02mn\x07]\x02\x02n*\x03\x02\x02\x02" +
        "op\x07_\x02\x02p,\x03\x02\x02\x02qs\t\x03\x02\x02rq\x03\x02\x02\x02st" +
        "\x03\x02\x02\x02tr\x03\x02\x02\x02tu\x03\x02\x02\x02uv\x03\x02\x02\x02" +
        "vw\b\x17\x02\x02w.\x03\x02\x02\x02\t\x0239>DFt\x03\b\x02\x02";
    static __ATN;
    static get _ATN() {
        if (!ExpressionLexer.__ATN) {
            ExpressionLexer.__ATN = new ATNDeserializer().deserialize(Utils.toCharArray(ExpressionLexer._serializedATN));
        }
        return ExpressionLexer.__ATN;
    }
}
//# sourceMappingURL=ExpressionLexer.js.map